/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener('scroll', function() {
  document.querySelectorAll('.image-banner--parallax .image-banner__bg').forEach(function(bg) {
    const banner = bg.closest('.image-banner--parallax');
    const rect = banner.getBoundingClientRect();

    // Always keep image scaled
    const scale = 1.19;

    // Calculate offset (gentle movement)
    let offset = rect.top * 0.08; // 0.08 = smoother/slower parallax

    // Max possible safe movement (scaled image size - container size)
    const extraHeight = bg.offsetHeight * scale - banner.offsetHeight;
    const maxOffset = extraHeight / 2;

    // Clamp so image never leaves section
    if (offset > maxOffset) offset = maxOffset;
    if (offset < -maxOffset) offset = -maxOffset;

    // Apply transform
    bg.style.transform = `scale(${scale}) translateY(${offset}px)`;
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("modal-search-input");
  console.log("[PredictiveSearchTabs] Loaded ✅ Input:", searchInput);

  // --- Function to find the right container ---
  function getResultsContainer() {
    let container =
      document.querySelector("#predictive-search-results") ||
      document.querySelector("predictive-search") ||
      document.querySelector("[data-predictive-search]");
    console.log("[PredictiveSearchTabs] Container found:", container);
    return container;
  }

  // --- Core function to initialize tabs ---
  function initPredictiveSearchTabs() {
    const tabButtons = document.querySelectorAll(".tab-button");
    const tabPanels = document.querySelectorAll(".predictive-search__panel");

    console.log("[PredictiveSearchTabs] Checking DOM...");
    console.log("→ Found tabButtons:", tabButtons.length);
    console.log("→ Found tabPanels:", tabPanels.length);

    if (!tabButtons.length || !tabPanels.length) {
      console.log("[PredictiveSearchTabs] Tabs not ready yet. Retrying...");
      return;
    }

    console.log("[PredictiveSearchTabs] ✅ Tabs found. Attaching listeners...");
    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const targetTab = button.getAttribute("data-tab");
        console.log("[PredictiveSearchTabs] Clicked tab:", targetTab);

        tabButtons.forEach((btn) => btn.classList.remove("active"));
        tabPanels.forEach((panel) => panel.classList.remove("active"));

        button.classList.add("active");
        const activePanel = document.querySelector(
          `.predictive-search__panel[data-tab-content="${targetTab}"]`
        );
        if (activePanel) activePanel.classList.add("active");
      });
    });

    // ✅ NEW FIX: Auto-activate the first available tab if none active
    const hasActive = document.querySelector(".tab-button.active");
    if (!hasActive && tabButtons.length > 0) {
      const firstTab = tabButtons[0];
      const firstTabName = firstTab.getAttribute("data-tab");
      const firstPanel = document.querySelector(
        `.predictive-search__panel[data-tab-content="${firstTabName}"]`
      );
      console.log(
        `[PredictiveSearchTabs] No active tab found → Auto-activating first: ${firstTabName}`
      );

      firstTab.classList.add("active");
      if (firstPanel) firstPanel.classList.add("active");
    }
  }

  // --- Watch DOM changes more broadly ---
  const container = getResultsContainer();
  if (container) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          console.log(
            "[PredictiveSearchTabs] DOM updated (new nodes detected) → trying init..."
          );
          setTimeout(initPredictiveSearchTabs, 500);
        }
      });
    });

    observer.observe(container, { childList: true, subtree: true });
    console.log("[PredictiveSearchTabs] Observer attached ✅");
  } else {
    console.warn("[PredictiveSearchTabs] No predictive search container found.");
  }

  // --- Listen for input changes ---
  if (searchInput) {
    searchInput.addEventListener("input", () => {
      console.log("[PredictiveSearchTabs] User typing → wait and reinit...");
      setTimeout(() => {
        initPredictiveSearchTabs();
      }, 800);
    });
  }

  // Initial try
  setTimeout(initPredictiveSearchTabs, 1500);
});

document.addEventListener("DOMContentLoaded", function () {
  function moveElements() {
    const addToCart = document.querySelector(".pdp-add-to-cart");
    const qtyPicker = document.querySelector(".product-single__box__block--quantity_selector");
    const freeShipping = document.querySelector(".product-single__box__block--free-shipping-bar");

    // Ensure ATC + QTY exist at minimum
    if (addToCart && qtyPicker) {

      // Move quantity selector above Add to Cart
      addToCart.parentNode.insertBefore(qtyPicker, addToCart);

      // Move free shipping bar ONLY if it exists
      if (freeShipping) {
        addToCart.parentNode.insertBefore(freeShipping, addToCart);
      }

      observer.disconnect(); // Stop observing
    }
  }

  const observer = new MutationObserver(moveElements);
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial check
  moveElements();
});


// gold first on pdp
document.addEventListener("DOMContentLoaded", () => {
  const variantRadios = document.querySelector("variant-radios");

  if (!variantRadios) {
    console.warn("⚠️ No variant-radios found.");
    return;
  }

  // Parse Shopify variant JSON
  const dataScript = variantRadios.querySelector("script[type='application/json']");
  if (!dataScript) {
    console.warn("⚠️ No variant JSON found.");
    return;
  }

  let variants = [];
  try {
    variants = JSON.parse(dataScript.textContent);
  } catch (err) {
    console.error("❌ Failed to parse variant JSON:", err);
    return;
  }

  // Build a map of availability by option value
  const availability = {};
  variants.forEach(v => {
    availability[v.option1] = v.available;
  });

  // Get all radios for Marbling Grade
  const radios = Array.from(
    variantRadios.querySelectorAll('input[type="radio"][name="Marbling Grade"]')
  );

  if (!radios.length) {
    console.warn("⚠️ No radios found for Marbling Grade.");
    return;
  }

  let goldOption = null;
  let firstAvailable = null;

  radios.forEach(radio => {
    const value = radio.value.trim();
    const available = availability[value] || false;

    console.log(`Checking "${value}": available=${available}`);

    if (available && !firstAvailable) {
      firstAvailable = radio;
    }

    if (available && value.toLowerCase() === "gold") {
      goldOption = radio;
    }
  });

  const toSelect = goldOption || firstAvailable;

  if (toSelect && !toSelect.checked) {
    toSelect.checked = true;
    toSelect.dispatchEvent(new Event("change", { bubbles: true }));
    console.log(`🎉 Auto-selected: ${toSelect.value}`);
  } else if (toSelect) {
    console.log(`ℹ️ Already selected: ${toSelect.value}`);
  } else {
    console.warn("⚠️ No available Marbling option found.");
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const shopPayEl = document.querySelector('shopify-payment-terms');
    if (shopPayEl && shopPayEl.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        #shopify-installments-content {
    padding-right: 0.375rem;
    font-size: 13px;
    font-family: 'Poppins';
    color: #212121;
}
#shopify-installments-content svg[aria-label="Shop Pay"] {
    width: 53px;
    height: 13px;
    color: #212121;
}
#shopify-installments-content .font-bold {
    font-weight: 300;
}
#shopify-installments-content svg[aria-label="Shop Pay"] {
    width: 53px;
    height: 13px;
}
#shopify-installments-cta {
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 12px;
    color: #8A6735;
}
      `;
      shopPayEl.shadowRoot.appendChild(style);
      clearInterval(interval);
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", function () {
  // Function to update heading text
  function updateReviewHeading() {
    const heading = document.querySelector(".kl_reviews__summary__header");
    if (heading && heading.textContent.trim() === "Customer reviews") {
      heading.textContent = "Reviews";
    }
  }

  // Run once in case it's already in the DOM
  updateReviewHeading();

  // Observe DOM for dynamic insertions
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      updateReviewHeading();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
